import React from 'react';

/**
 * AI Thinking Orb — signature animated fluid sphere that replaces loading spinners.
 * Uses 3 layered morphing blurs + mix-blend-mode to create a glowing neon-lime orb.
 *
 * Size prop controls pixel dimensions. Variant controls color.
 */
const ThinkingOrb = ({ size = 56, variant = 'neon', className = '', label }) => {
  const colorMap = {
    neon: { core: '#FF5436', glow: 'rgba(255,84,54,0.4)' },
    cream: { core: '#1C1D20', glow: 'rgba(28,29,32,0.3)' },
  };
  const c = colorMap[variant] || colorMap.neon;

  return (
    <div
      className={`inline-flex items-center gap-3 ${className}`}
      data-testid="thinking-orb"
    >
      <div
        className="thinking-orb relative flex-shrink-0"
        style={{ width: size, height: size }}
      >
        <div className="thinking-orb__layer2" />
        <div className="thinking-orb__layer1" />
        <div className="thinking-orb__core" />
      </div>
      {label && (
        <span className="label-micro text-obsidian-200">
          {label}
        </span>
      )}
    </div>
  );
};

export default ThinkingOrb;
